/** 昵称 / 后备串中取头像占位首字（按 Unicode 码位）；拉丁单字母用大写 */
export function avatarDisplayWord(primary?: string | null, fallback?: string | null): string {
  const raw = firstGrapheme(primary) || firstGrapheme(fallback);
  if (!raw) return '';
  if (/^[a-z]$/i.test(raw)) return raw.toUpperCase();
  return raw;
}

function firstGrapheme(s?: string | null): string | undefined {
  const t = s?.trim();
  if (!t) return undefined;
  const ch = Array.from(t)[0];
  return ch || undefined;
}
